module.exports = {"150822100":"巴彦高勒镇","150822101":"隆盛合镇","150822102":"渡口镇","150822103":"补隆淖镇","150822200":"沙金套海苏木","150822400":"磴口县农垦乌兰布和农场有限责任公司","150822401":"磴口县农垦巴彦套海农场有限责任公司","150822402":"磴口县农垦哈腾套海农场有限责任公司","150822403":"磴口县农垦包尔盖农场有限责任公司","150822404":"磴口县农垦纳林套海农场有限责任公司","150822405":"沙漠林业实验中心农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150822.json
// module id = 549
// module chunks = 0